/**
 * Creates boilerplate actions based on the state object provided.
 * Each action commits a mutation to mutate the state data.
 * Mutation names are in uppercase snake case based on the action name.
 *
 * @param {Object} stateObj - The state object containing properties.
 * @param {string} [prefix=''] - Optional prefix for action and mutation names.
 * @returns {Object} - The object storing action functions.
 */
const createActionsFactory = (stateObj, prefix = '') => {
  const actions = {};

  const toUpperCaseSnakeCase = (str) => str.replace(/([A-Z])/g, '_$1').toUpperCase();

  Object.keys(stateObj).forEach((prop) => {
    let baseName;
    if (prop.charAt(0) === '_') {
      baseName = `${prop.charAt(1).toUpperCase()}${prop.slice(2)}`;
    } else {
      baseName = `${prop.charAt(0).toUpperCase()}${prop.slice(1)}`;
    }
    const actionName = `set${prefix}${baseName}`;
    const mutationName = toUpperCaseSnakeCase(actionName);

    actions[actionName] = ({ commit }, payload) => {
      commit(mutationName, payload);
    };
  });
  return actions;
};

export default createActionsFactory;
